module.exports = __webpack_public_path__ + "static/media/craft_failure_second.57da9311.mp3";